import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Button, Table, Modal, Form, Input, notification } from "antd";
import {
  createOrganizationUserId,
  getOrganizationMappings,
  deleteOrganizationUser,
} from "../../utils/api";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";

import "./AddUserCode.css";

function AddUserCode({ selectedOrg, navStore }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [modalError, setModalError] = useState("");
  const [name, setName] = useState("");
  const [organizationMapping, setOrganizationMapping] = useState(null);
  const [loading, setLoading] = useState(false);

  const organizationMappingColumns = [
    {
      title: "User Id",
      dataIndex: "user_id",
      key: "user_id",
    },
    {
      title: "Action",
      key: "action",
      render: (record) => {
        return <Button onClick={() => deleteUserCode(record)}>Delete</Button>;
      },
    },
  ];

  const deleteUserCode = async (record) => {
    setLoading(true);
    await deleteOrganizationUser(selectedOrg, record.user_id);
    notification.open({
      message: `User ${record.user_id} deleted successfully`,
      description: "",
    });
    refreshOrgUserIds();
    setLoading(false);
  };

  const showModalMapping = () => {
    setName("");
    setModalError("");
    setIsModalVisible(true);
  };

  const refreshOrgUserIds = () => {
    getOrganizationMappings(selectedOrg).then((res) => {
      const organizations = res.map((x) => {
        const id = x.id;
        const user_id = x.user_id;
        return {
          id,
          user_id,
        };
      });
      setOrganizationMapping(organizations);
      setLoading(false);
    });
  };

  useEffect(() => {
    setLoading(true);
    refreshOrgUserIds();
  }, [selectedOrg]);

  const handleOk = async () => {
    try {
      setSubmitting(true);
      await createOrganizationUserId(selectedOrg, { name: name });
      notification.open({
        message: "Organization user added",
        description: "Organization user added successfully",
      });
      refreshOrgUserIds();
      setIsModalVisible(false);
      // refresh org
    } catch (e) {
      setModalError(e.response.data.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="AddUserCode">
      <Modal
        title={`Add Org User Code`}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Create"
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={submitting}
            onClick={handleOk}
          >
            Create
          </Button>,
        ]}
      >
        <Form
          name="basic"
          initialValues={{ remember: true }}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="name"
            name="name"
            rules={[{ required: true, message: "Please enter a name" }]}
          >
            <Input value={name} onChange={(e) => setName(e.target.value)} />

            {modalError && (
              <div className="AddUserCode__error">{modalError}</div>
            )}
          </Form.Item>
        </Form>
      </Modal>

      {loading && <LoadingSpinner />}
      {selectedOrg && (
        <div className="seperator">
          <Button
            type="primary"
            style={{ float: "right" }}
            onClick={showModalMapping}
          >
            Add User Code
          </Button>
        </div>
      )}
      {selectedOrg && (
        <Table
          dataSource={organizationMapping}
          columns={organizationMappingColumns}
        />
      )}
    </div>
  );
}

export default observer(AddUserCode);
